import type { FeedItemType } from '@/types';

export const useShowNotesSelector = (data: FeedItemType) => {
  if (
    data.source === 'needlnote' ||
    data.source === 'needl_notebooks' ||
    data.category === 'needl_notebooks'
  ) {
    return false;
  }

  return true;
};
